import {
  DialogBackdrop,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogPositioner,
  DialogRoot,
  DialogTitle,
} from "@chakra-ui/react";
import { useCallback, useRef } from "react";
import {
  AuthenticationForm,
  AuthenticationFormHandle,
} from "../AuthenticationDialog/AuthenticationForm";

interface LoginDialogProps {
  isShown: boolean;
  onClose: () => void;
  source?: string;
}

export const LoginDialog = ({ isShown, onClose, source }: LoginDialogProps) => {
  const authFormRef = useRef<AuthenticationFormHandle>(null);

  const closeDialog = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <DialogRoot
      open={isShown}
      onOpenChange={(details) => {
        if (!details.open) closeDialog();
      }}
    >
      <DialogBackdrop />
      <DialogPositioner>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>SIGN IN</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <AuthenticationForm
              ref={authFormRef}
              confirmLabel="Sign in"
              onClose={closeDialog}
              onComplete={closeDialog}
              source={source}
              screens={[]}
            />
          </DialogBody>
          <DialogCloseTrigger />
        </DialogContent>
      </DialogPositioner>
    </DialogRoot>
  );
};
